import { Profile } from "model/object/profile";

export const calculateProfilePercentage = (profile: Profile) => {
	let profilePct = 0;
	if (profile?.email) {
		profilePct += 0.1;
	}
	if (profile?.firstName) {
		profilePct += 0.15;
	}
	if (profile?.surname) {
		profilePct += 0.15;
	}
	if (profile?.phone) {
		profilePct += 0.15;
	}
	if (profile?.address1) {
		profilePct += 0.15;
	}
	if (profile?.postcode) {
		profilePct += 0.15;
	}
	if (profile?.dob) {
		profilePct += 0.15;
	}

	return Math.round(profilePct * 100);
};

export function generateRandom6AlphaNumeric() {
	const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	let result = "";
	for (let i = 0; i < 6; i++) {
		const randomIndex = Math.floor(Math.random() * chars.length);
		result += chars[randomIndex];
	}
	return result;
}

export function roundToTwo(num: number) {
	return Math.round(num * 100) / 100;
}
